import * as React from "react";
import { GraphCommand } from "./interfaces/config";
import "./Plot.scss";
import { evaluateGraph2Download, getTimesData, getXYCoordsValues, getXYZSurfaceValues, validateInputs, } from "./utils";
import { GraphBase } from "./GraphBase";
import { Graph3D } from "./Graph3D";
import { GraphCutHandler } from "./GraphCutHandler";
import { MarginContextContainer, MarginContext, } from "./Containers/MarginContextContainer";
import { GraphTopArea } from "./GraphTopArea";
import { AutoSizer } from "react-virtualized";
import { getInitialVisibleValues, VisibleValuesContainer, VisibleValuesContext, } from "./Containers/VisibleValuesContext";
import { TimeSelectorContainer } from "./TimeSelector";
import { GraphTimeProvider } from "./GraphTimeProvider";
export class Graph extends React.PureComponent {
    constructor(props) {
        super(props);
        this.togglePrintTitle = () => {
            this.setState({ printTitle: !this.state.printTitle });
        };
        this.handleOpenDialog = () => {
            this.setState({
                isDialogOpen: !this.state.isDialogOpen,
                printTitle: !this.state.isDialogOpen,
            });
        };
        this.handleDownload = (value, dimension) => {
            this.setState({
                imageDimensions: Object.assign(Object.assign({}, this.state.imageDimensions), { [dimension]: value }),
            });
        };
        this.showPlotAsPolar = () => {
            this.setState({
                showAsPolar: !this.state.showAsPolar,
            });
        };
        this.handleShowPopup = () => {
            const currentState = this.state.showPopup;
            this.setState({ showPopup: !currentState });
        };
        this.handleResize = ({ width, height }) => {
            this.setState({
                legendHeight: height - this.margins.bottom,
                svgDimensions: { width, height },
                imageDimensions: { width, height },
            });
        };
        this.handleSwitch = (target) => () => {
            this.setState(() => ({
                brush: target,
            }));
        };
        this.resetSurfaceZoom = () => {
            this.setState({ resetGraph3d: !this.state.resetGraph3d });
        };
        this.toggleLegend = () => {
            this.setState({ isLegendOpen: !this.state.isLegendOpen });
        };
        let xValues, yValues, zValues;
        const { graph, ignoreFileName } = props;
        validateInputs(graph, props.data || {});
        this.margins = { top: 3, bottom: 45, left: 40, right: 225 };
        if (graph.command === GraphCommand.graph3d ||
            graph.command === GraphCommand.levels ||
            graph.command === GraphCommand.cuts) {
            ({ xValues, yValues, zValues } = getXYZSurfaceValues(graph, ignoreFileName));
        }
        else {
            ({ xValues, yValues } = getXYCoordsValues(graph, ignoreFileName));
        }
        this.glCanvasRef = React.createRef();
        this.plotContainerRef = React.createRef();
        this.legendContainerRef = React.createRef();
        this.state = {
            imageDimensions: {
                height: null,
                width: null,
            },
            isDialogOpen: false,
            xValues,
            yValues,
            zValues,
            brush: false,
            legendHeight: 0,
            showAsPolar: false,
            resetGraph3d: false,
            printTitle: false,
            svgDimensions: {
                height: null,
                width: null,
            },
            isLegendOpen: true,
            showPopup: true,
        };
    }
    componentDidMount() {
        const { setRightMargin, isLegendOpen } = this.context;
        if (!isLegendOpen) {
            setRightMargin(40);
        }
        else {
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.graph !== this.props.graph) {
            let xValues, yValues, zValues;
            const { graph, ignoreFileName } = this.props;
            validateInputs(graph, this.props.data || {});
            if (graph.command === GraphCommand.graph3d ||
                graph.command === GraphCommand.levels ||
                graph.command === GraphCommand.cuts) {
                ({ xValues, yValues, zValues } = getXYZSurfaceValues(graph, ignoreFileName));
            }
            else {
                ({ xValues, yValues } = getXYCoordsValues(graph, ignoreFileName));
            }
            this.glCanvasRef = React.createRef();
            this.plotContainerRef = React.createRef();
            this.legendContainerRef = React.createRef();
            this.setState({
                xValues,
                yValues,
                zValues,
                brush: false,
            });
        }
    }
    renderGraph(graph, data, margins, height, width, xValues, yValues, zValues) {
        let graph2render = null;
        switch (graph.command) {
            case GraphCommand.graph:
            case GraphCommand.bar:
            case GraphCommand.cuts:
            case GraphCommand.timegraph:
                graph2render = (React.createElement(MarginContextContainer, { initialMargins: this.margins },
                    React.createElement(GraphBase, { brush: this.state.brush, showAsPolar: this.state.showAsPolar, data: data, glCanvasRef: this.glCanvasRef, graph: graph, legendContainerRef: this.legendContainerRef, legendHeight: this.state.legendHeight, plotContainerRef: this.plotContainerRef, svgDimensions: {
                            height,
                            width,
                        }, xValues: xValues, yValues: yValues, hideTitle: this.props.hideTitle, ignoreFileName: this.props.hideTitle, isImage2Download: false, isLegendOpen: this.state.isLegendOpen, toggleLegend: this.toggleLegend, showPopup: this.state.showPopup })));
                break;
            case GraphCommand.graph3d:
            case GraphCommand.levels:
                graph2render = (React.createElement(Graph3D, { xValues: xValues, yValues: yValues, zValues: zValues, data: data, graph: graph, margins: margins, svgDimensions: { height, width }, ignoreFileName: this.props.ignoreFileName, hideTitle: this.props.hideTitle, reset: this.state.resetGraph3d, dragmode: this.state.brush ? "zoom" : "pan", printTitle: this.state.printTitle }));
                break;
        }
        return graph2render;
    }
    render() {
        var _a;
        const { data, graph } = this.props;
        const { yValues, xValues, zValues } = this.state;
        const dialogOptions = {
            isDialogOpen: this.state.isDialogOpen,
            handleDialog: this.handleOpenDialog,
        };
        const downloadOptions = {
            imageDimensions: this.state.imageDimensions,
            plotTitle: graph.title,
            handleDownload: this.handleDownload,
        };
        const isGraph2Download = evaluateGraph2Download(dialogOptions.isDialogOpen, graph.command);
        const realLegendHeight = (_a = document.querySelectorAll(".ReactVirtualized__Grid__innerScrollContainer")[0]) === null || _a === void 0 ? void 0 : _a.clientHeight;
        return (React.createElement("div", { style: {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%",
            } },
            React.createElement(GraphCutHandler, { xValues: xValues, yValues: yValues, zValues: zValues, data: data, graph: graph, render: (data, xValues, yValues, graph) => (React.createElement(VisibleValuesContainer, { initialVisibleValues: getInitialVisibleValues({
                        graph,
                        ignoreFileName: this.props.hideTitle,
                    }) },
                    React.createElement(VisibleValuesContext.Consumer, null, ({ visibleValues }) => {
                        const timesData = getTimesData(graph, data, visibleValues, this.props.hideTitle);
                        return (React.createElement(GraphTimeProvider, { times: timesData },
                            React.createElement(GraphTopArea, { folderType: this.props.folderType, hideTitle: this.props.hideTitle, svgDimensions: this.state.svgDimensions, graph: graph, brush: this.state.brush, dialogOptions: dialogOptions, downloadOptions: downloadOptions, glCanvasRef: this.glCanvasRef, handleSwitch: this.handleSwitch, plotContainerRef: this.plotContainerRef, legendContainerRef: this.legendContainerRef, printTitle: this.state.printTitle, resetSurfaceZoom: this.resetSurfaceZoom, showPlotAsPolar: this.showPlotAsPolar, togglePrintTitle: this.togglePrintTitle, popupFunctionalities: {
                                    showPopup: this.state.showPopup,
                                    handleShowPopup: this.handleShowPopup,
                                }, baseFileName: this.props.baseFileName }),
                            React.createElement("div", { style: { flex: "1 1 auto" } },
                                React.createElement(AutoSizer, { onResize: this.handleResize }, ({ width = 1000, height = 400 }) => {
                                    const printingHeight = height - 25;
                                    const legendHeight = printingHeight > realLegendHeight
                                        ? printingHeight
                                        : realLegendHeight;
                                    return (React.createElement("div", { className: "plot-container", style: {
                                            width: width + "px",
                                            height: height + "px",
                                            overflow: "hidden",
                                        } },
                                        this.renderGraph(graph, data, this.margins, height, width, xValues, yValues, zValues),
                                        isGraph2Download ? (React.createElement(MarginContextContainer, { initialMargins: this.margins },
                                            React.createElement("div", { id: "printableElement" },
                                                React.createElement(GraphBase, { brush: this.state.brush, showAsPolar: this.state.showAsPolar, data: data, glCanvasRef: this.glCanvasRef, graph: graph, legendContainerRef: this.legendContainerRef, legendHeight: legendHeight, plotContainerRef: this.plotContainerRef, svgDimensions: this.state.imageDimensions.height >
                                                        this.margins.top
                                                        ? this.state.imageDimensions
                                                        : Object.assign(Object.assign({}, this.state.imageDimensions), { height: 250 }), xValues: xValues, yValues: yValues, hideTitle: this.props.hideTitle, ignoreFileName: this.props.hideTitle, isImage2Download: true, isLegendOpen: this.state.isLegendOpen, toggleLegend: this.toggleLegend, showPopup: false })))) : null));
                                })),
                            timesData.length > 0 && !isGraph2Download ? (React.createElement(TimeSelectorContainer, null)) : null));
                    }))) })));
    }
}
Graph.contextType = MarginContext;
//# sourceMappingURL=Graph.js.map